import { UserProfileStore } from '../user-profile';

export const AD_LOGIN_START = 'AD_LOGIN_START';
export const AD_LOGIN_SUCCESS = 'AD_LOGIN_SUCCESS';
export const AD_LOGIN_FAILED = 'AD_LOGIN_FAILED';
export const AD_LOGOUT_START = 'AD_LOGOUT_START';
export const AD_LOGOUT_SUCCESS = 'AD_LOGOUT_SUCCESS';
export const AD_LOGOUT_FAILED = 'AD_LOGOUT_FAILED';
export const AD_LOGIN_REDIRECT_SUCCESS = 'AD_LOGIN_REDIRECT_SUCCESS';
export const AD_LOGIN_REDIRECT_FAILED = 'AD_LOGIN_REDIRECT_FAILED';
export const AD_ACCESS_TOKEN_START = 'AD_ACCESS_TOKEN_START';
export const AD_ACCESS_TOKEN_SUCCESS = 'AD_ACCESS_TOKEN_SUCCESS';
export const AD_ACCESS_TOKEN_FAILED = 'AD_ACCESS_TOKEN_FAILED';
export const INITIALIZE_AD_AUTH_SUCCESS = 'INITIALIZE_AD_AUTH_SUCCESS';
export const INITIALIZE_AD_AUTH_FAILED = 'INITIALIZE_AD_AUTH_FAILED';
export const CIAM_LOGIN_STARTED = 'CIAM_LOGIN_STARTED';
export const CIAM_LOGIN_SUCCESS = 'CIAM_LOGIN_SUCCESS';

export interface AdfsAuth {
  login?: unknown;
  loginError?: unknown;
  msalError?: unknown;
  adLoginRedirectError?: unknown;
  tokenPending?: boolean;
  tokenSet?: unknown;
  tokenError?: unknown;
  redirect?: string;
  loginPending?: boolean;
}

export type CiamLoginResponse = {
  user: Partial<UserProfileStore>;
  claims: string[];
  accessToken: string;
};
